import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const unitOfMeasurementBaseEndpoint = ENDPOINTS.UNITOFMEASUREMENT;

// Unit Of Measurement API
export const unitOfMeasurementApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["unitOfMeasurement"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUnitOfMeasurement: builder.query({
        query: (payload) => `${unitOfMeasurementBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "unitOfMeasurement" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      
      addUnitOfMeasurement: builder.mutation({
        query: (requestData) => ({
          url: `${unitOfMeasurementBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "unitOfMeasurement" }],
      }),
      updateUnitOfMeasurement: builder.mutation({
        query: ({id,requestData}) => ({
          url: `${unitOfMeasurementBaseEndpoint}${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "unitOfMeasurement" }],
      }),
      deleteUnitOfMeasurement: builder.mutation({
        query: (id) => ({
          url: `${unitOfMeasurementBaseEndpoint}${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "unitOfMeasurement" }],
      }),
     
    }),
  });

// Export hooks for usage in components

export const { useGetUnitOfMeasurementQuery, useAddUnitOfMeasurementMutation, useUpdateUnitOfMeasurementMutation, useDeleteUnitOfMeasurementMutation } = unitOfMeasurementApi;
